import { callerCreator } from "../callerCreator";
import { homeSlice } from "./homeSlice";

export default callerCreator(homeSlice.actions);
